export type TimeValueTuple = [number, number];

/**
 * Previously mixed raw residual into SMA; now returns SMA only (or raw if SMA is empty).
 * Kept so named exports stay stable for bundlers / partial HMR updates.
 */
export function blendSmaWithRawResidual(
  raw: TimeValueTuple[],
  sma: TimeValueTuple[],
  _windowSize: number,
): TimeValueTuple[] {
  if (Array.isArray(sma) && sma.length > 0) {
    return sma;
  }
  return Array.isArray(raw) ? raw : [];
}

export function simpleMovingAverage(data: TimeValueTuple[] | null | undefined, windowSize: number): TimeValueTuple[] {
  if (!Array.isArray(data) || windowSize <= 0 || data.length < windowSize) {
    return [];
  }

  const result: TimeValueTuple[] = [];
  let sum = 0;

  for (let i = 0; i < data.length; i += 1) {
    const currentPoint = data[i];
    const currentValue = currentPoint?.[1];
    sum += typeof currentValue === 'number' ? currentValue : Number(currentValue);

    if (i >= windowSize) {
      const outgoingPoint = data[i - windowSize];
      const outgoingValue = outgoingPoint?.[1];
      sum -= typeof outgoingValue === 'number' ? outgoingValue : Number(outgoingValue);
    }

    if (i >= windowSize - 1) {
      result.push([currentPoint[0], sum / windowSize]);
    }
  }

  return result;
}
